import { Link } from "@StarberryUtils"
import React, { useState, useEffect } from "react"
import { Container, Row, Col } from "react-bootstrap"
import Slider from "react-slick"
import axios from "axios"
import "./SimilarPropery.scss"
import ScrollAnimation from "react-animate-on-scroll"
import { numberWithCommas } from "@Components/common/common-functions.js"
const SimilarPropery = props => {
  

  //
  const [propItems, setPropItems] = useState([])
  const strapiconfig = {
    headers: {
        Authorization:
            `Bearer ${process.env.GATSBY_STRAPI_FORM_TOKEN}`,
    },
  }
  const getitems = async url => {
    try {
      const { data } = await axios.get(url, strapiconfig)
      // 
      // console.log("PropertySimilar", data)
      setPropItems(data)
    } catch (error) {
      // console.error(error)
    }
  }

  useEffect(() => {
    // 
    let url =
      process.env.GATSBY_STRAPI_SRC +
      "/stb-lists/item/Property-details?pid=" +
      props.pid

    getitems(url)
  }, [])
  //
  const settings = {
    dots: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
    ],
  }

  return (
    <>
      {
      propItems.length > 0 ?
        <div className="case-studies similar-properties">
          <Container>
            <Row>
              <Col xs>
                <div className="case-studies-block">
                  <div className="case-studies-content">
                    <h2 className="d-lg-none">Other properties that may interest you</h2>
                    <ScrollAnimation animateIn="fadeIn">
                      <h2 className="d-none d-lg-block">
                        Other properties that may interest you
                      </h2>
                    </ScrollAnimation>
                  </div>
                  <div className="case-studies-list slick-pagination">
                    <Slider {...settings}>
                      {propItems &&
                        propItems.map(hit => {
                          // property details url structure
                          let uriStr = "";

                          if( hit.search_type === "sales" ) {
                            uriStr = `property-for-sale/`
                          } else if ( hit.search_type === "lettings" ) {
                            uriStr = `property-to-rent/`
                          }
                          if ( hit.department === "international" ) {
                            uriStr = `international-property/`
                          }else if (hit.department === "dubai_properties") {
                            uriStr = `dubai-property/`
                           }
                          // property details url structure

                          return (
                            <a href={'/'+uriStr+hit.slug+'-'+hit.id+'/'} className="case-studies-news img-zoom">
                              <ScrollAnimation animateIn="fadeIn" dealy={500}>
                                <div className="case-studies-img">
                                  <img src={hit.images[0].url} alt="" />
                                  {/* <div className="on-map d-flex">
                                    <FloorPlanModalDetails floorplanimg={hit.images[0].url} icon={'true'} image_count={hit.images.length} />
                                    <Link to="#">
                                      <i className="icon-play-btn"></i>{" "}
                                      <span> 1</span>
                                    </Link>
                                  </div> */}
                                </div>
                                <div className="case-studies-title">
                                  <div className="detail-head d-flex align-items-center justify-content-between">
                                    <h2 className="price">
                                      {
                                        hit.search_type === "lettings" ?
                                        <>&pound;{numberWithCommas(Math.round(hit.price))}</>
                                        :
                                        <>&pound;{numberWithCommas(hit.price)}</>
                                      }
                                    </h2>
                                    {/* <Link className="wishlist-icn" to="#">
                                      <i className="icon-heart"></i>
                                    </Link> */}
                                  </div>
                                  <h3>
                                    <Link href={'/'+uriStr+hit.slug+'-'+hit.id+'/'}>{hit.title}</Link>
                                  </h3>
                                  <span className="add-txt">
                                    {hit.display_address}
                                  </span>
                                  {/* <span className="distance d-flex align-items-center">
                                    <i className="icon-station"></i>Oxford Road (1.2
                                    miles)
                                  </span> */}
                                </div>
                              </ScrollAnimation>
                            </a>
                          )
                        })}
                    </Slider>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      : '' }
    </>
  )
}

export default SimilarPropery
